/*
    设备完好率 - top100设备
 */
import React, { Component } from "react";
import ScGridTable from "@/components/display/table/gridTableCore";
import moment from "moment";
import { getStubRate } from "../../../fetch/fetchApi";
import fetchHandler from "../../../fetch/fetchHandler";
import "@/assets/stylus/data_analysis.styl";

class StubIntactTop100 extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      tableConfig: this.initTable(), // 初始化表格
      tableDate: [], // 表格数据初始化
      sortFunc: {
        // 排序方式初始化
        sortKey: "2", // 2：完好率，1：离线率，0：故障率
        sortFun: "1", // 1：由低到高，-1：由高到低
      },
      cityId: this.props.param.cityId, // 获取父传子参数 城市id
      operationProperty: this.props.param.operationProperty, // 获取父传子参数 运营类型总项
      operationMode: this.props.param.operationMode, // 获取父传子参数 运营类型细项
      type: this.props.param.type, // 获取父传子参数 设备类型
      time: this.props.param.date, // 获取父传子参数 时间
    };
    this.layout = [
      "inline", // 横向布局
      "vertical", // 弹窗布局
      "horizontal", // 纵向布局
    ];
  }

  /**
   *  父组件条件修改子组件进行更新
   */
  componentWillMount() {
    this.setState({
      currentState: this.queryStubName,
      currentDate: this.queryCurrent,
    });

    this.queryEndCodeChargInfo();
  }

  // 秒转换
  handleSecord(value) {
    const day = Math.floor(value / (24 * 3600)); // Math.floor()向下取整
    const hour = Math.floor((value - day * 24 * 3600) / 3600);
    const minute = Math.floor((value - day * 24 * 3600 - hour * 3600) / 60);
    const second = value - day * 24 * 3600 - hour * 3600 - minute * 60;
    if (day > 0) {
      return `${day}天${hour}时${minute}分`; // + second + "秒";
    } else if (hour > 0) {
      return `${hour}时${minute}分`; // + second + "秒";
    } else if (minute > 0) {
      return `${minute}分`; // + second + "秒";
    } else {
      return `${second}秒`;
    }
  }

  // 获取选取的日期
  changeDay = (value) => {
    console.log(value);
  };

  // 开启新开页方法
  openTab = (param, e) => {
    this.props.onAdd(e, param);
    // this.props.handle && this.props.handle()
  };

  // 开启设备完好率趋势详情页面
  openDetail = (props) => {
    this.openTab(
      {
        stubId: props.stubId, // 传递参数 设备编号
        choosedData: moment(new Date()).subtract(0, "d").format("YYYYMMDD"), // 传递参数，选择日期
      },
      {
        key: "stubIntactDetail",
        titleText: "设备完好率趋势",
      },
    );
  };

  /**
   * 初始化表格方法
   */
  initTable() {
    const tableConfig = {
      tableKey: "stubGroupListTableTop100",
      tableColumns: [
        {
          name: "排名",
          key: "serial",
          colType: "textCol",
          align: "center",
        },
        {
          name: "设备编号",
          key: "stubId",
          colType: "textCol",
          align: "left",
          render: (value) => {
            const props = {
              stubId: value,
            };
            return (
              <a
                onClick={() => {
                  this.openDetail(props);
                }}>
                {value}
              </a>
            );
          },
        },
        {
          name: "所属电站",
          key: "stubGroupName",
          colType: "tipCol",
          align: "left",
        },
        {
          name: "地区",
          key: "cityName",
          colType: "textCol",
          align: "left",
          render: (value, row) => {
            if (row.areaName === "--" || row.cityName === "--" || row.provinceName === "--") {
              return "--";
            } else {
              return `${row.provinceName}-${row.cityName}-${row.areaName}`;
            }
          },
        },
        {
          name: "运营类型",
          key: "operationMode",
          colType: "textCol",
          align: "left",
          render: (value, row) => {
            if (row.operationProperty.toString() === "1") {
              if (value.toString() === "0") {
                return <div>运营-他营</div>;
              } else if (value.toString() === "1") {
                return <div>运营-联营</div>;
              } else if (value.toString() === "2") {
                return <div>运营-星充直营</div>;
              } else if (value.toString() === "3") {
                return <div>运营-加盟直营</div>;
              } else if (value.toString() === "4") {
                return <div>运营-互联互通</div>;
              } else if (value.toString() === "5") {
                return <div>运营-人人电站</div>;
              } else {
                return <div>--</div>;
              }
            } else if (row.operationProperty.toString() === "0") {
              if (value.toString() === "0") {
                return <div>运维-私桩</div>;
              } else if (value.toString() === "1") {
                return <div>运维-非私桩</div>;
              } else if (value.toString() === "2") {
                return <div>--</div>;
              }
            } else {
              return "--";
            }
          },
        },
        {
          name: "设备类型",
          key: "type",
          colType: "textCol",
          align: "left",
          render: (value) => {
            switch (value) {
              case 0:
                return "交流电";
              case 1:
                return "直流电";
              case 2:
                return "交直流";
              default:
                return "未知";
            }
          },
        },
        {
          name: "可用时长",
          message: (
            <div className='mcjs'>
              <p>
                <b>可用时长：</b>运营时长 + 维护时长；
              </p>
            </div>
          ),
          key: "totalAvailableDuration",
          colType: "textCol",
          align: "left",
          render: (value) => {
            return value !== "--" ? this.handleSecord(value) : "--";
          },
        },
        {
          name: "运营时长",
          message: (
            <div className='mcjs'>
              <p>
                <b>运营时长：</b>空闲时长（包含插枪空闲时长） + 充电中时长 + 车位占用时长 + 故障时长 + 离线时长 +
                升级中时长 + 预约等待充电中时长 + 储能中时长 + 在线预约中时长 + 充满时长；
              </p>
            </div>
          ),
          key: "totalOperationDuration",
          colType: "textCol",
          align: "left",
          render: (value) => {
            return value !== "--" ? this.handleSecord(value) : "--";
          },
        },
        {
          name: "可用率",
          message: (
            <div className='mcjs'>
              <p>
                <b>可用率</b>=（可用时长 - 维护时长）/可用时长
              </p>
            </div>
          ),
          key: "availableRate",
          colType: "textCol",
          // sorter:true,
          align: "center",
          render: (value) => {
            return `${value}%`;
          },
        },
        {
          name: "故障时长",
          message: (
            <div className='mcjs'>
              <p>
                <b>故障时长：</b>
                设备变更为故障状态开始计时到设备变更为另一个状态为止的时间段。
              </p>
            </div>
          ),
          key: "totalErrorDuration",
          colType: "textCol",
          align: "left",
          render: (value) => {
            return value !== "--" ? this.handleSecord(value) : "--";
          },
        },
        {
          name: "故障率",
          message: (
            <div className='mcjs'>
              <p>
                <b>故障率</b>=故障时长/运营时长
              </p>
            </div>
          ),
          key: "errorRate",
          colType: "textCol",
          // sorter:true,
          align: "center",
          render: (value) => {
            return `${value}%`;
          },
        },
        {
          name: "离线时长",
          key: "totalOfflineDuration",
          colType: "textCol",
          align: "left",
          render: (value) => {
            return value !== "--" ? this.handleSecord(value) : "--";
          },
          message: (
            <div className='mcjs'>
              <p>
                <b>离线时长：</b>
                设备变更为离线状态开始计时到设备变更为另一个状态为止的时间段。
              </p>
            </div>
          ),
        },
        {
          name: "离线率",
          key: "offlineRate",
          colType: "textCol",
          // sorter:true,
          align: "center",
          render: (value) => {
            return `${value}%`;
          },
          message: (
            <div className='mcjs'>
              <p>
                <b>离线率</b>=离线时长/运营时长
              </p>
            </div>
          ),
        },
        {
          name: "完好时长",
          key: "cityName",
          colType: "textCol",
          align: "left",
          render: (value, row) => {
            if (
              row.totalOperationDuration !== "--"
              && row.totalErrorDuration !== "--"
              && row.totalOfflineDuration !== "--"
            ) {
              const info = row.totalOperationDuration
              - row.totalErrorDuration - row.totalOfflineDuration;
              return this.handleSecord(info);
            } else {
              return "--";
            }
          },
          message: (
            <div className='mcjs'>
              <p>
                <b>完好时长</b>=运营时长 - 故障时长 -离线时长。
              </p>
            </div>
          ),
        },
        {
          name: "完好率",
          key: "intactRate",
          colType: "textCol",
          // sorter:true,
          align: "center",
          render: (value) => {
            return `${value}%`;
          },
          message: (
            <div className='mcjs'>
              <p>
                <b>完好率</b>=(运营时长-离线时长-故障时长)/运营时长
              </p>
            </div>
          ),
        },
      ],
      tableChange: (pagination, filters, sorter) => {
        console.log(sorter);
      },
      tableParam: {
        pagecount: 10,
      },
      dataApi: this.state ? this.state.tableDate : [],
      autoRefresh: !1, // 设置为true 直接加载grid数据
    };
    return tableConfig;
  }

  // 调用接口获取数据
  queryEndCodeChargInfo() {
    fetchHandler(getStubRate, {
      cityId: this.state.cityId,
      operationProperty: this.state.operationProperty,
      operationMode: this.state.operationMode,
      type: this.state.type,
      time: this.state.time,
      sortType: this.state.sortFunc.sortKey,
      sortWay: this.state.sortFunc.sortFun,
    }).then((res) => {
      console.log(res);
      this.setState(
        {
          tableDate: res.data ? res.data : [], // 设置表格数据
        },
        () => {
          this.setState({
            tableConfig: this.initTable(), // 重置表格
          });
        },
      );
    });
  }

  /**
   * 父组件参数改变，方法
   */
  componentWillReceiveProps(nextProps) {
    /**
     * 判断是否改变排序方式
     */
    if (
      this.state.sortFunc.sortKey === nextProps.sort.sortKey
      && this.state.sortFunc.sortFun === nextProps.sort.sortFun
    ) {
      /**
       * 排序方式未改变
       */
      if (
        this.props.param.cityId === nextProps.param.cityId
        && this.props.param.operationProperty === nextProps.param.operationProperty
        && this.props.param.operationMode === nextProps.param.operationMode
        && this.props.param.type === nextProps.param.type
        && this.props.param.date === nextProps.param.date
      ) {
        /**
         * 如果查询参数没有改变，直接返回，不继续执行
         */
        return;
      } else {
        /**
         * 如果查询参数改变，设置参数，调用接口获取数据，重新渲染表格
         */
        console.log("查询表格，并重新加载表格");
        this.setState(
          {
            cityId: nextProps.param.cityId,
            operationProperty: nextProps.param.operationProperty,
            operationMode: nextProps.param.operationMode,
            type: nextProps.param.type,
            time: nextProps.param.date,
          },
          () => {
            this.queryEndCodeChargInfo();
          },
        );
      }
    } else {
      /**
       * 排序方式改变，修改参数，调用接口，重新渲染表格
       */
      this.setState(
        {
          sortFunc: nextProps.sort,
          cityId: nextProps.param.cityId,
          operationProperty: nextProps.param.operationProperty,
          operationMode: nextProps.param.operationMode,
          type: nextProps.param.type,
          time: nextProps.param.date,
        },
        () => {
          // 查询表格，并重新加载表格
          this.queryEndCodeChargInfo();
          console.log("查询表格，并重新加载表格");
        },
      );
    }
    console.log(nextProps);
  }

  render() {
    const val = (
      <div className='analysis-content-3'>
        <ScGridTable config={this.state.tableConfig} />
      </div>
    );

    return val;
  }
}

export default StubIntactTop100;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/stubIntactRate/stubIntactTop100.js